import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AgoraRTC from 'agora-rtc-sdk-ng';
import { Button, Tooltip, Input, Form, message, Avatar } from 'antd';
import slugify from 'slugify';


import * as COMMON from '../common/agora';
import CONSTANT from '../config/constant';
import MediaPlayer from '../component/media-player';
import './meeting.css';

AgoraRTC.setLogLevel(4);
AgoraRTC.setArea({
	areaCode: "ASIA"
});

const client = AgoraRTC.createClient({ codec: 'vp8', mode: 'rtc' });


const Meeting = () => {
	const { id } = useParams();
	let navigate = useNavigate();

	if (!id) navigate('/');

	const [userName, setUserName] = useState('');

	const [muteVideo, setMuteVideo] = useState(false);
	const [muteAudio, setMuteAudio] = useState(false);

	let grid = 12;


	const {
		localAudioTrack, localVideoTrack, leave, join, joinState, remoteUsers, startScreenShare
	} = COMMON.useAgora(client);


	let gridCol =
		remoteUsers.length === 0 ? 1 : remoteUsers.length <= 1 ? 2 : remoteUsers.length <= 2 ? 3 : 4;
	const gridColSize = remoteUsers.length <= 2 ? 1 : 2;
	let gridRowSize =
		remoteUsers.length <= 2
			? remoteUsers.length
			: Math.ceil(remoteUsers.length / 2);


	const handleJoin = (values) => {
		if (values && values.userName) {
			let userName = slugify(values.userName, ' ');
			userName = `${userName}-${Math.floor(Math.random() * 100)}`;
			setUserName(userName);
			const token = COMMON.generateToken(CONSTANT.AGORA.APP_ID, CONSTANT.AGORA.APP_CERT, id,userName);
			join(CONSTANT.AGORA.APP_ID, id, token, userName);
		}
		else {
			message.warning('Vui lòng nhập Họ tên của bạn để bắt đầu tham gia cuộc hội thoại.')
		}

	}

	const handleMuteVideo = () => {
		if (!localVideoTrack) return;
		let _muteVideo = !muteVideo;
		localVideoTrack.setMuted(_muteVideo);
		setMuteVideo(_muteVideo);
	}

	const handleMuteAudio = async () => {
		if (!localAudioTrack) return;
		let _muteAudio = !muteAudio;
		await localAudioTrack.setMuted(_muteAudio);
		setMuteAudio(_muteAudio);
	}

	const handleLeave = async () => {
		await leave();
		navigate('/');
	}


	return (

		<div className="wrapper meeting">
			<div className="ag-header">
				<div className="ag-header-lead">
					<img className="header-logo" src='/static/images/vivmedic-white.png' alt="logo" />
					<span>Vivmedic Meet v1.0</span>
				</div>
				{
					id &&
					<div className="ag-header-msg">
						Phòng:&nbsp;<span id="room-name">{id}</span>
					</div>
				}

			</div>

			<div className="ag-main">
				<div className="ag-container">

					{
						userName === '' ?
							<div className="wrap-username">
								<div className="note">Quý khách vui lòng nhập Họ và tên của mình để bắt đầu tham gia cuộc hội thoại.</div>
								<Form
									layout="inline"
									onFinish={handleJoin}
								>
									<Form.Item name="userName">
										<Input className="input" autoComplete="off" placeholder="Nhập Họ tên của bạn" />
									</Form.Item>
									<Form.Item>
										<Button type="primary" className="btn-connect" htmlType="submit">Tham gia</Button>
									</Form.Item>
								</Form>
							</div>
							:
							<div id="ag-canvas">
								<div className="list-pa">
									<div
										style={{
											"--grid-size": gridCol,
											"--grid-col-size": gridColSize,
											"--grid-row-size": gridRowSize,
										}}
										className="participants"
									>

										{
											remoteUsers.length > 0 && remoteUsers.map((user, index) => (
												<div className="pa-item" key={index}>
													<MediaPlayer videoTrack={user.videoTrack} audioTrack={user.audioTrack} />
													<div className="name">{user.uid.split('-')[0]}</div>
												</div>
											))
										}

										<div className={`pa-item ${remoteUsers.length > 0 ? 'you' : ''}`}>
											<MediaPlayer videoTrack={localVideoTrack} audioTrack={undefined} />
											{
												muteVideo && <Avatar style={{backgroundColor: `#${Math.floor(Math.random()*16777215).toString(16)}`}} className="avatar-mute" size={80}>{userName[0]}</Avatar>
											}
											<div className="name">Bạn</div>
											<div className="icon-mute">
												{
													muteVideo && <span className="icon"><i className='fas fa-video-slash'></i></span>
												}
												{
													muteAudio && <span className="icon"><i className='fas fa-microphone-slash'></i></span>
												}
											</div>
										</div>
									</div>
								</div>

								<div className="ag-btn-group">
									<Tooltip title={muteAudio ? 'Nhấn vào để bật tiếng' : 'Nhấn vào để tắt tiếng'}>
										<Button className={`btn ${muteAudio ? 'disable' : ''}`} onClick={handleMuteAudio}>
											<i className={`fas fa-microphone${muteAudio ? '-slash' : ''}`}></i>
										</Button>
									</Tooltip>

									<Tooltip title={muteVideo ? 'Nhấn vào để bật ảnh' : 'Nhấn vào để tắt ảnh'}>
										<Button className={`btn ${muteVideo ? 'disable' : ''}`} onClick={handleMuteVideo}>
											<i className={`fas fa-video${muteVideo ? '-slash' : ''}`}></i>
										</Button>
									</Tooltip>

									{/* <Tooltip title='Chia sẻ màn hình'>
                      <Button className="btn" onClick={handleStartScreenShare}>
                        <i className="fas fa-desktop"></i>
                      </Button>
                    </Tooltip> */}

									<Tooltip title='Bấm vào để kết thúc cuộc hội thoại'>
										<Button className="btn disable" onClick={handleLeave}>
											<i className="fas fa-phone"></i>
										</Button>
									</Tooltip>
								</div>
							</div>
					}
				</div>
			</div>

			<div className="ag-footer">
				<div>
					<a className="ag-href" href="https://vivmedic.com">
						<span>Thiết kế bởi Vivmedic</span>
					</a>
				</div>
				<div>
					<span>Hỗ trợ: (+84) 818 889 668</span>
				</div>
			</div>

		</div>

	)
}
export default Meeting;